import { jsx as l, jsxs as H, Fragment as rt } from "react/jsx-runtime";
import { c as nt } from "react/compiler-runtime";
import at from "./assets/IndoorRadio.js";
import it from "./assets/OutdoorRadio.js";
import lt from "./assets/WarningBadge.js";
const Z = {
  xsmall: {
    base: 22,
    icon: 16,
    stroke: 1
  },
  radioTable: {
    base: 32,
    icon: 24,
    stroke: 1.25
  },
  small: {
    base: 48,
    icon: 18,
    stroke: 1.5
  },
  medium: {
    base: 64,
    icon: 24,
    stroke: 2
  },
  large: {
    base: 80,
    icon: 30,
    stroke: 2.5
  }
}, ct = {
  GOOD: "#226a58",
  BAD: "#9B0505",
  WARNING: "#DB5E04",
  PARTIALLY_GOOD: "#DB5E04",
  UNKNOWN: "#9E9E9E",
  NA: "#9E9E9E",
  CBRS: "#C600CA",
  OPEN_CELL: "#00A8CA"
}, mt = (K) => {
  const t = nt(48), {
    parameters: a,
    size: D,
    type: L,
    onClick: C,
    showSector: P,
    isBorderRadio: z,
    forRadioTable: T,
    warning: G
  } = K, f = D === void 0 ? "medium" : D, M = L === void 0 ? "outdoor" : L, I = P === void 0 ? !0 : P, b = z === void 0 ? !1 : z, r = T === void 0 ? !1 : T, F = G === void 0 ? !1 : G, e = Z[f] ?? Z.medium, N = ct[a.health];
  let h, k, m, u, g, p, x, $;
  if (t[0] !== e || t[1] !== r || t[2] !== b || t[3] !== C || t[4] !== a || t[5] !== I || t[6] !== f || t[7] !== F) {
    const U = () => {
      if (!I)
        return null;
      const s = e.base / 2, o = s / 1.4 - e.stroke - (b ? 2.3 : 0);
      if ("angle" in a) {
        const {
          angle: c,
          beamwidth: i,
          gain: n,
          channelColor: E
        } = a;
        return X(c, i, n, E || "#000000", s, o);
      }
      return a.sectors.map((c, i) => {
        const {
          angle: n,
          beamwidth: E,
          gain: w,
          channelColor: W
        } = c;
        return X(n, E, w, W, s, o, i);
      });
    }, X = (s, o, c, i, n, E, w) => {
      const W = w === void 0 ? 0 : w, J = Math.min(c || 0, 30) / 30, d = E + E * (J * 0.5), Q = s - o / 2, V = s + o / 2, Y = Q * Math.PI / 180, j = V * Math.PI / 180, _ = n + d * Math.sin(Y), tt = n - d * Math.cos(Y), et = n + d * Math.sin(j), st = n - d * Math.cos(j), ot = o > 180 ? 1 : 0;
      return o === 0 || o === 360 ? /* @__PURE__ */ l("circle", { cx: n, cy: n, r: d, fill: i + "88", stroke: i, strokeWidth: e.stroke }, `sector-${W}`) : /* @__PURE__ */ l("path", { d: `M ${n} ${n} L ${_} ${tt} A ${d} ${d} 0 ${ot} 1 ${et} ${st} Z`, fill: i + "66", stroke: i, strokeWidth: e.stroke }, `sector-${W}`);
    };
    let B;
    t[16] !== e.base || t[17] !== r || t[18] !== b || t[19] !== f ? (B = () => {
      if (!b)
        return null;
      const s = f === "xsmall", o = r ? s ? 0.6 : 0.8 : 1.6, c = s ? 2 : 3, i = s ? 1.25 : 2, n = r ? s ? "2, 1" : "4, 2" : "8, 4";
      return /* @__PURE__ */ H(rt, { children: [
        /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: e.base / 2 - o, fill: "transparent", stroke: "#FFF", strokeWidth: c }),
        /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: e.base / 2 - o, fill: "transparent", stroke: "#000", strokeWidth: i, strokeDasharray: n })
      ] });
    }, t[16] = e.base, t[17] = r, t[18] = b, t[19] = f, t[20] = B) : B = t[20];
    const q = B;
    let O;
    t[21] !== e.base || t[22] !== F ? (O = () => {
      if (!F)
        return null;
      const s = Math.max(e.base * 0.32, 12), o = e.base - s;
      return /* @__PURE__ */ l(lt, { size: s, x: o, y: 0 });
    }, t[21] = e.base, t[22] = F, t[23] = O) : O = t[23], k = O;
    let v;
    t[24] !== e || t[25] !== r || t[26] !== a.network ? (v = (s) => {
      const {
        type: o
      } = s;
      return o === "indoor" ? /* @__PURE__ */ l(at, { fill: r ? "#000" : "#FFF", scale: 0.75, dimensions: e, text: a.network }) : /* @__PURE__ */ l(it, { fill: r ? "#000" : "#FFF", scale: 1, dimensions: e, text: a.network });
    }, t[24] = e, t[25] = r, t[26] = a.network, t[27] = v) : v = t[27], h = v, p = e.base, x = e.base, $ = `0 0 ${e.base} ${e.base}`, m = C, u = U(), g = q(), t[0] = e, t[1] = r, t[2] = b, t[3] = C, t[4] = a, t[5] = I, t[6] = f, t[7] = F, t[8] = h, t[9] = k, t[10] = m, t[11] = u, t[12] = g, t[13] = p, t[14] = x, t[15] = $;
  } else
    h = t[8], k = t[9], m = t[10], u = t[11], g = t[12], p = t[13], x = t[14], $ = t[15];
  let R;
  t[28] !== e.base || t[29] !== e.stroke || t[30] !== r || t[31] !== N ? (R = !r && /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: (e.base / (r ? 1 : 1.8) - e.stroke * 2) / 2, fill: N, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))" }), t[28] = e.base, t[29] = e.stroke, t[30] = r, t[31] = N, t[32] = R) : R = t[32];
  let A;
  t[33] !== h || t[34] !== M ? (A = /* @__PURE__ */ l(h, { type: M }), t[33] = h, t[34] = M, t[35] = A) : A = t[35];
  let S;
  t[36] !== k ? (S = k(), t[36] = k, t[37] = S) : S = t[37];
  let y;
  return t[38] !== m || t[39] !== u || t[40] !== g || t[41] !== R || t[42] !== A || t[43] !== S || t[44] !== p || t[45] !== x || t[46] !== $ ? (y = /* @__PURE__ */ H("svg", { width: p, height: x, viewBox: $, onClick: m, children: [
    u,
    g,
    R,
    A,
    S
  ] }), t[38] = m, t[39] = u, t[40] = g, t[41] = R, t[42] = A, t[43] = S, t[44] = p, t[45] = x, t[46] = $, t[47] = y) : y = t[47], y;
};
export {
  mt as default
};
